import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { updateInitialGroupByName } from "../../utils/updateInitialGroupById";

export default function InviteAccept() {
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    (async () => {
      const params = new URLSearchParams(search);
      const token = params.get("token");

      if (!token) {
        navigate("/login?joined=0&status=missing_token", { replace: true });
        return;
      }

      try {
        const res = await fetch(
          `${process.env.REACT_APP_PREDICTIONS_API}/api/invites/accept`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
          }
        );

        if (!res.ok) {
          navigate("/login?joined=0&status=invalid_or_expired", {
            replace: true,
          });
          return;
        }

        const data = await res.json();

        if (data.status === "need_registration") {
          const params = new URLSearchParams();
          if (token) params.set("code", token);

          navigate(`/invited?${params.toString()}`, { replace: true });
          return;
        }

        if (data.status === "joined") {
          try {
            await updateInitialGroupByName(data.groupName);
          } catch (e) {
            console.error(e);
          }

          navigate("/dashboard", { replace: true });
          return;
        }

        navigate("/login?joined=0&status=unknown", { replace: true });
      } catch (e) {
        console.error(e);
        navigate("/login?joined=0&status=error", { replace: true });
      }
    })();
  }, [search, navigate]);

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <div className="spinner-border" role="status" />
        <p className="mt-3">Processing…</p>
      </div>
    </div>
  );
}
